export default "__VITE_ASSET__CAK3_gcg__"